import { takeEvery } from 'redux-saga/effects';

import * as rewardsPageActions from 'store/modules/rewardsPage';

import { load } from './utils';

export default function* listenLoad() {
  yield takeEvery(rewardsPageActions.load.toString(), load);
}
